import { CalendarClock, LayoutGrid, Search } from 'lucide-react';
import Icon from '@/components/primitives/Icon.jsx';

const SUGGESTIONS = [
  { icon: LayoutGrid, text: 'Which of my connected apps can you work in, and what can you do in each?' },
  { icon: Search, text: 'Find invoicing apps in the catalog and tell me which ones connect with an API key.' },
  { icon: CalendarClock, text: "Every Monday at 9, send me a summary of last week's new orders." }
];

/** Requests to start from on the assistant home. Choosing one sends it as written. */
const SuggestionList = ({ onChoose, disabled }) => {
  return (
    <section className="assistant-suggestions" aria-labelledby="assistant-suggestions-title">
      <h2 id="assistant-suggestions-title" className="assistant-section-title">
        Try a request
      </h2>
      <ul className="assistant-suggestions__list">
        {SUGGESTIONS.map((suggestion) => (
          <li key={suggestion.text}>
            <button type="button" className="assistant-suggestion" disabled={disabled} onClick={() => onChoose(suggestion.text)}>
              <Icon icon={suggestion.icon} />
              <span>{suggestion.text}</span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SuggestionList;
